'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actionTypes = require('./action-types');

var _actionTypes2 = _interopRequireDefault(_actionTypes);

var _actions = require('linksoft/core/actions');

var _actions2 = _interopRequireDefault(_actions);

var _autoQueryHelper = require('linksoft/utils/auto-query-helper');

var _autoQueryHelper2 = _interopRequireDefault(_autoQueryHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var moduleActions = {

    update: function update(e) {
        return {
            type: _actionTypes2.default.UPDATE,
            facets: e.facets
        };
    },
    change: function change(item, source) {
        return function (dispatch, getState) {
            var state = getState().facets || {};
            if (state.processing) {
                return;
            }
            dispatch({ type: _actionTypes2.default.CHANGE, item: item });
            setTimeout(function () {
                (0, _autoQueryHelper2.default)(source);
            }, 0);
        };
    }
};

_actions2.default.add('facets', moduleActions);
exports.default = moduleActions;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/facets/actions.js
// module id = 1044
// module chunks = 0